module.exports = __webpack_public_path__ + "sky.ccd9fc28f484de933a17.png";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/images/themes/footer/style04/sky.png
// module id = ../../../../../src/assets/images/themes/footer/style04/sky.png
// module chunks = 2